/* tslint:disable */
/* eslint-disable */
export enum CreditType {
  Partial = 'PARTIAL',
  Full = 'FULL',
}
